import axios from '../axios';
import { checkResponse, getProjectId } from '../utils';

/**
 * @function getRoleList
 * @returns {Object} role.data 返回角色基本信息
 * @returns {String}  role.data[0].name 返回用户名称
 * @returns {String}  role.data[0].id 返回用户id
 */
const getRoleList = () => {
  return axios.get(`/api/v1/projects/${getProjectId()}/roles`).then(checkResponse);
};

/**
 * @function getRolePermission
 * @param {Number} id 角色id
 * @returns {Array} permission.data 返回角色权限
 */
const getRolePermission = (id) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/roles/${id}/permissions`)
    .then(checkResponse);
};

/**
 * @function getCustomTree
 * @returns {Array} customTree.data 返回角色权限树
 */
const getCustomTree = () => {
  return axios.get(`/api/v1/projects/${getProjectId()}/organizations/to_tree`).then(checkResponse);
};

/**
 * @function updatePermission 更新角色权限
 * @param {Number} id 角色 id
 * @param {Object} data 角色任务权限，案件权限，平台权限
 * @returns {Object} res.msg 'ok'
 */
const updatePermission = (id, data) => {
  return axios
    .put(`/api/v1/projects/${getProjectId()}/roles/${id}/configure`, data)
    .then(checkResponse);
};

/**
 * @function createRole 新建角色
 * @param {Object} data 角色名称, 复制权限的角色id
 */
const createRole = (data) => {
  return axios.post(`/api/v1/projects/${getProjectId()}/roles`, data).then(checkResponse);
};

/**
 * @function editRole 编辑角色
 * @param {Number} id 角色id
 * @param {Object} data 角色名称
 */
const editRole = (id, data) => {
  return axios.put(`/api/v1/projects/${getProjectId()}/roles/${id}`, data).then(checkResponse);
};

/**
 * @function deleteRole 删除角色
 * @param {Number} id 角色id
 */
const deleteRole = (id) => {
  return axios.delete(`/api/v1/projects/${getProjectId()}/roles/${id}`).then(checkResponse);
};

/**
 * @function getCreatedUser 获取上报人
 */
const getCreatedUser = () => {
  return axios.get(`/api/v1/projects/${getProjectId()}/users?pagination=false`).then(checkResponse);
};
/**
 * @function getConfigs 功能配置-获取App相似案件定位坐标间距
 */
const getConfigs = () => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/configs?slug=similarity-ucase-basic`)
    .then(checkResponse);
};

/**
 * @function getConfigs 功能配置-更新App相似案件定位坐标间距
 */
const updateConfig = (data) => {
  return axios
    .post(`/api/v1/projects/${getProjectId()}/similarity/updateConfig`, data)
    .then(checkResponse);
};

export {
  getRoleList,
  getRolePermission,
  getCustomTree,
  updatePermission,
  createRole,
  editRole,
  deleteRole,
  getCreatedUser,
  getConfigs,
  updateConfig,
};
